import React, { useState } from "react";

//UI Material
import {
  Alert,
  CircularProgress,
  Grid,
  Stack,
  SwipeableDrawer,
  TextField,
} from "@mui/material";

//Helpers
import {
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Local components
import ContainedButton from "../basics/ContainedButton";
import ModalWindow from "../Modal";

//Material Icons
import { Upload } from "@mui/icons-material";

export default function SerialNumberDrawer({
  open,
  setOpen,
  product,
  getData,
}) {
  // ==========> Component States <==========
  //State for serial number
  const [serial, setSerial] = useState("");
  //State for loading
  const [isLoading, setIsLoading] = useState(false);
  //State for open confirmation modal
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");

  // ==========> Component Functions <==========
  //Function to set a serial identifier to the product
  const setSerialIdentifier = async () => {
    setIsLoading(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        "/orders/set-product-serial",
        {
          productId: product.productId,
          serial,
        }
      );
      const jsonResponse = await requestResponse.json();
      if (jsonResponse.status === "ok") {
        setModalText("Identificador serial asignado.");
        setModalDescription(
          `Se ha asignado el identificador serial ${serial} al producto ${product.productId}`
        );
        createInteraction();
      } else {
        setModalText(
          "No se pudo asignar el identificador serial a este producto."
        );
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      setModalText("No se pudo realizar la acción.");
      setModalDescription(
        "Error al hacer los cambios, por favor verifica tu conexión a internet e inténtalo nuevamente."
      );
    }
    setModalOpen(true);
    setConfirmationModalOpen(false);
    setIsLoading(false);
    getData();
  };

  //Function to generate the interaction for setting the serial identifier
  const createInteraction = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        "/interactions/create-product-interaction",
        {
          productId: product.productId,
          action: "SERIAL_SETTED",
          value: serial,
        }
      );
      const jsonResponse = await requestResponse.json();
    } catch (error) {
      setModalText("No se pudo publicar la interacción.");
      setModalDescription(
        "Error al hacer al publicar la interacción, por favor contactar a soporte técnico."
      );
      setModalOpen(true);
    }
  };

  // ==========> Component <==========
  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {
        /**empty arrow function */
      }}
    >
      <Grid
        container
        justifyContent="center"
        sx={{ padding: "15px" }}
        textAlign="center"
        spacing={1}
      >
        <Grid item xs={12}>
          {typographyForSubtitles("Identificador Serial", "secondary")}
        </Grid>
        <Grid item xs={12} sm={5} sx={{ mb: 2 }}>
          <Alert severity="info">{`Identificador serial para el producto ${product.productId}. Por favor asegúrese de ingresar correctamente la información ya que esta no se podrá editar nuevamente.`}</Alert>
        </Grid>
        <Grid item xs={12}>
          <Stack alignItems="center">
            {typographyForText("Número Serial (S/N)", "bold")}
            <TextField
              value={serial}
              onChange={(e) => {
                setSerial(e.target.value);
              }}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ mt: 4 }}>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <Stack direction="row" justifyContent="center" spacing={1}>
              <ContainedButton
                text="Cancelar"
                color="error"
                onClick={() => setOpen(false)}
              />
              <ContainedButton
                text="Guardar cambios"
                variant={serial === "" ? "disabled" : "contained"}
                endIcon={<Upload />}
                onClick={() => {
                  setConfirmationModalOpen(true);
                }}
              />
            </Stack>
          )}
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
          setConfirmationModalOpen(false);
          setOpen(false);
        }}
      />
      <ModalWindow
        isOpen={confirmationModalOpen}
        handleClose={() => setConfirmationModalOpen(false)}
        title={"Confirmación de Identificador Serial"}
        text={`¿El identificador serial ingresado ${serial} es correcto? Este identificador no podrá cambiarse nuevamente.`}
        leftText="Cancelar"
        leftClick={() => {
          setConfirmationModalOpen(false);
        }}
        leftColor="error"
        rightClick={() => {
          setSerialIdentifier();
          setConfirmationModalOpen(false);
        }}
        rightText="Confirmar"
      />
    </SwipeableDrawer>
  );
}
